import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";
import { createArray } from "utils/surveyHelper";

const FeedbackSurveyParticipnat = () => {
  return (
      <ul>
        {createArray(5).map((index) => (
          <li key={`shimmer-participant-survey-list-${index}`}>
            <p style={{display:"flex",alignItems:"center"}}>
              <SkeletonLoader
                type={"circle"}
                height={38}
                width={38}
                rightGap={8}
              />{" "}
              <b>
                <SkeletonLoader type={"text"} height={22} width={100} />
              </b>
            </p>
            <p>
              <span>
                <SkeletonLoader type={"text"} height={23} width={220} />
              </span>{" "}
              <button type="button">
                <SkeletonLoader type={"text"} height={23} width={160} />
              </button>
            </p>
          </li>
        ))}
      </ul>
  );
};

export default FeedbackSurveyParticipnat;
